module.exports = __webpack_public_path__ + "img/slide_movil.b69c861a.jpg";